module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-section"
  }, [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.select_one_answer')))]), _vm._v(" "), _c('select', {
    staticClass: "klickart-select",
    on: {
      "change": function($event) {
        return _vm.jumpUpdateOptionId({
          jump: _vm.jump,
          index: 0,
          event: $event
        })
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_one_answer')))]), _vm._v(" "), _vm._l((_vm.optionList), function(option, index) {
    return _c('option', {
      domProps: {
        "value": option.id,
        "selected": option.id === _vm.jump.options_ids[0]
      }
    }, [_vm._v(_vm._s(option.label))])
  })], 2)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-17c53034!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/selects/SingleAnswer.vue
 ** module id = 771
 ** module chunks = 1
 **/